import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TeamStoryCard = ({ avatar, avatarAlt, name, role, quote, date }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-300">
      <div className="flex items-start gap-4 mb-4">
        <div className="relative">
          <div className="w-14 h-14 rounded-full overflow-hidden ring-2 ring-primary/20">
            <Image 
              src={avatar} 
              alt={avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full border-2 border-background flex items-center justify-center">
            <Icon name="Check" size={12} color="var(--color-success-foreground)" strokeWidth={3} />
          </div>
        </div>
        <div className="flex-1">
          <h4 className="text-base font-bold text-foreground">{name}</h4>
          <p className="text-sm text-muted-foreground">{role}</p>
        </div>
      </div>
      <div className="relative">
        <Icon name="Quote" size={24} color="var(--color-primary)" className="absolute -top-2 -left-2 opacity-20" />
        <p className="text-sm text-foreground leading-relaxed pl-4 italic">{quote}</p>
      </div>
      <div className="flex items-center gap-2 mt-4 pt-4 border-t border-border">
        <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
        <span className="text-xs text-muted-foreground">{date}</span>
      </div>
    </div>
  );
};

export default TeamStoryCard;